import { render } from "./LogIn.vue?vue&type=template&id=48a2dc38&scoped=true"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import "./LogIn.vue?vue&type=style&index=0&id=48a2dc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a2dc38"]])

export default __exports__